import React, { useState } from 'react'
import { Badge, Fab, Tooltip } from '@mui/material'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'
import { useNavigate } from 'react-router-dom'
import SupportRequestPopup from './SupportRequestPopup'
import { useSupportCounterContext } from '../../context/supportCounterContext/SupportCounterContextProvider'
import { PAGE_URLS } from '../../utils/helpers/helper'
import { useAuthContext } from '../../context/auth/AuthContextProvider'
import { isSupportAgent } from '../../utils/helpers/supportHelper'

type SupportButtonProps = {
  navWidth: number
}

const SupportButton = ({ navWidth }: SupportButtonProps) => {
  const navigate = useNavigate()
  const { user } = useAuthContext()
  const { supportCounter } = useSupportCounterContext()
  const [openPopup, setOpenPopup] = useState<boolean>(false)

  const hasUnread = supportCounter > 0

  // Don't show the button for accounts with ROLE_SUPPORT
  if (isSupportAgent(user)) {
    return null
  }

  return (
    <React.Fragment>
      <Tooltip
        title={
          hasUnread
            ? `${supportCounter} unread support ${supportCounter === 1 ? 'reply' : 'replies'}`
            : 'Contact Support'
        }
        placement="left"
      >
        <Badge
          color="secondary"
          badgeContent={supportCounter}
          max={9}
          overlap="circular"
          sx={{
            position: 'fixed',
            bottom: 24,
            right: 24,
            zIndex: (theme) => theme.zIndex.speedDial,
          }}
        >
          <Fab
            color="primary"
            aria-label={hasUnread ? 'Open Support' : 'Contact Support'}
            onClick={() =>
              hasUnread ? navigate(PAGE_URLS.SUPPORT) : setOpenPopup(true)
            }
          >
            <SupportAgentIcon />
          </Fab>
        </Badge>
      </Tooltip>

      <SupportRequestPopup
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        navWidth={navWidth}
      />
    </React.Fragment>
  )
}

export default SupportButton
